import { createApp } from 'vue';
import App from './App.vue';
import router from "./router";
import AOS from 'aos';
import 'aos/dist/aos.css';
import i18n from './i18n';
import store from "./state/store";
import Auth from './state/auth';

import BootstrapVueNext from 'bootstrap-vue-next';
import vClickOutside from "click-outside-vue3";
import VueApexCharts from "vue3-apexcharts";
import { vMaska } from "maska";

import VueFeather from 'vue-feather';

import Date from './common/date';
import Number from './common/number';
import Table from './common/table';
import Modal from './common/modals';

import '@/assets/scss/config/material/app.scss';
import '@/assets/scss/mermaid.min.css';
import 'bootstrap/dist/js/bootstrap.bundle';


const PRODUCTION_URL = 'https://pphback.metacoresystemsinc.com/api';
const LOCAL_URL = 'http://localhost:8000/api';

console.log(PRODUCTION_URL)
console.log(LOCAL_URL)

AOS.init({
    easing: 'ease-out-back',
    duration: 1000
});

const app = createApp(App);

app.config.globalProperties.$baseURL = PRODUCTION_URL

app.use(store)
    .use(router)
    .use(VueApexCharts)
    .use(BootstrapVueNext)
    .mixin(Auth)
    .mixin(Date)
    .mixin(Number)
    .mixin(Table)
    .mixin(Modal)
    .component(VueFeather.type, VueFeather)
    .directive("maska", vMaska)
    .use(i18n)
    .use(vClickOutside)
    .mount('#app');
